import { Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Alacrity from '../../../assets/images/alacrity.png';
import Altimeter from '../../../assets/images/altimeter.png';
import BrightServe from '../../../assets/images/brightServ.png';
import ServPro from '../../../assets/images/servePro.svg';
import ServiceMaster from '../../../assets/images/ServiceMaster-Logo.svg';
interface Props {
  companyId: string | undefined;
}

const ServiceCompanyLogo = (props: Props) => {
  const theme: Theme = useTheme();
  let logo = '';
  const logoWidth = theme.custom.styles.logoWidth;
  const logoHeight = theme.custom.styles.logoHeight;

  switch (props.companyId) {
    case 'alacrity':
      logo = Alacrity;
      break;
    case 'altimeter':
      logo = Altimeter;
      break;
    case 'brightserv':
      logo = BrightServe;
      break;
    case 'servicemaster':
      logo = ServiceMaster;
      break;
    case 'servpro':
      logo = ServPro;
      break;
    default:
      break;
  }
  return (
    <div>
      <img src={logo} alt="logo" width={logoWidth} height={logoHeight} data-testid="logoImage"></img>
    </div>
  );
};

export default ServiceCompanyLogo;
